/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import * as global from "../../js/global";
	import * as helper from "../../js/helper";
	import full_loading from "../components/full-loading.vue";
	const __vue_script__ ={
        components: {
            full_loading:full_loading,
        },
		name:'login_widget',
        props:{
        },
        data: function(){
            return {
                global,
                helper,
                frappe,
                exceptions:[],
                loading: false,
                for_agency: true,
                full_name:"",
                mobile:"",
                email_address:"",
                resident_id:"",
                cr_file:null,
                fl_file:null,
                errors:[],
                form_sent:false,
                form_disable:false,
                otp_sent:false,
                wrong_otp:false,
                otp:"",
                t_sid: null,
                reg_error:false,
                reg_done:false,
                registration_policy:null,
                policy_agreed:false,
                confirm_form:false,
                confirm_form_error:false,
                continue_to_signup:false
            }
        },
        methods: {
            load_data: async function(){
                global.emitter.emit("show-full-loading");
                this.is_loading = true;
                let params = {
                };
                let url = "/api/method/maalek.api.get_registration_policy";
                let res = await $.ajax({
                    url: url,
                    type: "GET",
                    data: params
                });
                this.registration_policy = res.message;
                this.is_loading = false;
                global.emitter.emit("hide-full-loading");
            },
            isUserExist:async function(){
                global.emitter.emit("show-full-loading");
                this.loading = true;
                try {
                    let params = {
                        "phone_number":this.mobile,
                    }
                    let res = await $.ajax({
                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                        url: "/api/method/maalek.api.is_user_exist",
                        type: "GET",
                        data: params //for GET request
                        // data: JSON.stringify(params) //for POST request
                    });
                    if(res.message == false ){
                        this.loading = false;
                        global.emitter.emit("hide-full-loading");
                        return false
                    }
                    this.loading = false;
                    global.emitter.emit("hide-full-loading");
                    helper.showException("Mobile number already registered");
                    return true
                } catch (e) {
                    this.loading = false;
                    global.emitter.emit("hide-full-loading");
                    var exceptions = helper.showException(e);
                    return true
                }
            },
            sendMobileVerification: async function(){
                if(!this.verify_form()){
                    this.show_errors();
                    return;
                }
                if(await this.isUserExist()){
                    return;
                }
                this.loading = true;
                let params = {
                    mobile_no : '+966'+this.mobile.substring(1, this.mobile.length)
                };
                try {
                    let res = await $.ajax({
                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                        url: "/api/method/maalek.api.twilio_api.send_otp",
                        type: "GET",
                        data: params //for GET request
                        // data: JSON.stringify(params) //for POST request
                    });
                    this.t_sid = res.message;
                    this.form_disable = true;
                    this.otp_sent = true;
                    this.loading = false;
                } catch (e) {
                    console.log(e);
                    this.loading = false;
                    this.otp_sent = false;
                    this.form_disable = false;
                    var exceptions = helper.showException(e);
                }
            },
            onPickFile: function(ref){
                this.$refs[ref].click()
            },
            onFileCrFilePicked: function(event) {
                const files = event.target.files
                if (files && files[0]) {
                    this.cr_file = {};
                    this.cr_file["file"] = files[0].name;
                    this.cr_file["type"] = files[0].type;
                    const fileReader = new FileReader();
                    fileReader.readAsDataURL(files[0]);
                    let reader = new FileReader;
                    reader.onload = e => {
                        this.cr_file["data"] = e.target.result;
                    }
                    reader.readAsDataURL(files[0]);
                    this.$forceUpdate();
                }
            },
            onFileFlFilePicked: function(event) {
                const files = event.target.files
                if (files && files[0]) {
                    this.fl_file = {};
                    this.fl_file["file"] = files[0].name;
                    this.fl_file["type"] = files[0].type;
                    const fileReader = new FileReader();
                    fileReader.readAsDataURL(files[0]);
                    let reader = new FileReader;
                    reader.onload = e => {
                        this.fl_file["data"] = e.target.result;
                    }
                    reader.readAsDataURL(files[0]);
                    this.$forceUpdate();
                }
            },
            confirm_otp_and_register: async function(){
                this.form_sent = true;
                let params = {
                    "mobile":'+966'+this.mobile.substring(1, this.mobile.length),
                    "full_name":this.full_name,
                    "email_address":this.email_address,
                    "for_agency":this.for_agency?1:0,
                    "resident_id":this.resident_id,
                    "cr_file":this.cr_file,
                    "fl_file":this.fl_file,
                    "t_sid":this.t_sid,
                    "otp":this.otp
                }
                try {
                    let res = await $.ajax({
                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                        url: "/api/method/maalek.api.register_user",
                        type: "POST",
                        // data: params //for GET request
                        data: JSON.stringify(params) //for POST request
                    });
                    if (res.full_name != null && res.full_name != "") {
                        this.reg_error = false;
                        this.reg_done = true;
                        window.location.replace(document.referrer);
                        return;
                    }
                    this.reg_error = true;
                    this.reg_done = false;
                    helper.showException("There is something wrong. Please try again.");
                } catch (e) {
                    this.reg_error = true;
                    this.reg_done = false;
                    var exceptions = helper.showException(e);
                }
                
                this.loading = false
            },
            verify_form: function(){
                this.errors = [];
                if(this.full_name.length < 3){
                    this.errors.push("full_name");
                }
                if(!this.mobile.match('^05[0-9]{8}$')) {
                    this.errors.push("mobile");
                }
                var mailformat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                var trimed_email = this.email_address.replace(/\s+/g, "");
                if(trimed_email.length > 0 && !trimed_email.match(mailformat)){
                    this.errors.push("email");
                }
                if(this.for_agency && (!this.resident_id || this.resident_id.length != 10)){
                    this.errors.push("resident_id");
                }
                if(this.for_agency && this.cr_file == null){
                    this.errors.push("cr_file");
                }
                if(this.for_agency && this.fl_file == null){
                    this.errors.push("fl_file");
                }
                if(this.errors.length > 0){
                    return false;
                }
                return true;
            },
            show_errors: function(){
                if(this.errors.includes("full_name")){
                    return helper.showException("Please enter your full name");
                }
                if(this.errors.includes("mobile")) {
                    return helper.showException("Please enter valid mobile no. (05xxxxxxxx)");
                }
                if(this.errors.includes("email")){
                    return helper.showException("Please enter valid email address");
                }
                if(this.errors.includes("resident_id")){
                    return helper.showException("You must enter your company's registration id.");
                }
                if(this.errors.includes("cr_file")){
                    return helper.showException("You must provide Company Registration Document");
                }
                if(this.errors.includes("fl_file")){
                    return helper.showException("You must provide Fal License Document");
                }
            },
        }, 
        mounted() {
            this.load_data();
        },
        computed:{
        }
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "add-listing" }, [
    _vm.registration_policy && !_vm.continue_to_signup
      ? _c(
          "div",
          {
            staticStyle: {
              padding: "10px",
              background: "#eeeeee",
              border: "2px grey SOLID",
              height: "300px",
              overflow: "auto"
            }
          },
          [
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.registration_policy) }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "features-content mt-2" }, [
              _c("ul", { staticClass: "d-flex justify-content-start" }, [
                _c(
                  "li",
                  {
                    attrs: { role: "button" },
                    on: {
                      click: function($event) {
                        _vm.policy_agreed = !_vm.policy_agreed
                      }
                    }
                  },
                  [
                    _vm.policy_agreed
                      ? _c("i", { staticClass: "ri-checkbox-circle-fill" })
                      : _c("i", {
                          staticClass: "ri-checkbox-blank-circle-line"
                        }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.helper.t("I agree")) +
                        "\n                "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.policy_agreed
                ? _c(
                    "a",
                    {
                      staticClass: "btn default-btn equalizer",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.continue_to_signup = true
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.helper.t("Continue to Sign Up")) +
                          "\n            "
                      )
                    ]
                  )
                : _vm._e()
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.policy_agreed && _vm.continue_to_signup
      ? _c("h3", [_vm._v(_vm._s(_vm.helper.t("Sign Up")))])
      : _vm._e(),
    _vm._v(" "),
    _vm.policy_agreed && _vm.continue_to_signup
      ? _c(
          "div",
          { staticClass: "user-form-content sign-up" },
          [
            _c(
              "form",
              {
                staticClass: "user-form",
                attrs: { action: "#", method: "post" }
              },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 p-2" }, [
                    _c(
                      "ul",
                      {
                        staticClass: "nav nav-pills mb-3",
                        attrs: { id: "pills-tab", role: "tablist" }
                      },
                      [
                        _c(
                          "li",
                          {
                            staticClass: "nav-item",
                            attrs: { role: "presentation" }
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "nav-link toggle-btn",
                                class: _vm.for_agency ? "active" : "",
                                attrs: { type: "button", role: "tab" },
                                on: {
                                  click: function($event) {
                                    _vm.for_agency = true
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.helper.t("Agency")))]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticClass: "nav-item",
                            attrs: { role: "presentation" }
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "nav-link toggle-btn",
                                class: !_vm.for_agency ? "active" : "",
                                attrs: { type: "button", role: "tab" },
                                on: {
                                  click: function($event) {
                                    _vm.for_agency = false
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.helper.t("Individual User")))]
                            )
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.mobile,
                            expression: "mobile"
                          }
                        ],
                        staticClass: "form-control border-radius",
                        class: _vm.errors.includes("mobile") ? "error" : "",
                        attrs: {
                          type: "text",
                          placeholder: _vm.helper.t(
                            _vm.for_agency
                              ? "* Mobile Number for the Entity's Main Account (05xxxxxxxx)"
                              : "* Mobile Number (05xxxxxxxx)"
                          ),
                          disabled: _vm.loading || _vm.otp_sent
                        },
                        domProps: { value: _vm.mobile },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.mobile = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.full_name,
                            expression: "full_name"
                          }
                        ],
                        staticClass: "form-control border-radius",
                        class: _vm.errors.includes("full_name") ? "error" : "",
                        attrs: {
                          type: "text",
                          placeholder:
                            "*" +
                            _vm.helper.t(
                              _vm.for_agency
                                ? "Entity Name According to Commercial Registration"
                                : "Full Name"
                            ),
                          disabled: _vm.loading
                        },
                        domProps: { value: _vm.full_name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.full_name = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.email_address,
                            expression: "email_address"
                          }
                        ],
                        staticClass: "form-control border-radius",
                        class: _vm.errors.includes("email") ? "error" : "",
                        attrs: {
                          type: "text",
                          placeholder: _vm.helper.t("Email (optional)"),
                          disabled: _vm.loading
                        },
                        domProps: { value: _vm.email_address },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.email_address = $event.target.value
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.for_agency
                    ? _c("div", { staticClass: "col-12" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.resident_id,
                                expression: "resident_id"
                              }
                            ],
                            staticClass: "form-control border-radius",
                            class: _vm.errors.includes("resident_id")
                              ? "error"
                              : "",
                            attrs: {
                              type: "text",
                              placeholder: _vm.helper.t(
                                "* Commercial Registration Number"
                              ),
                              disabled: _vm.loading
                            },
                            domProps: { value: _vm.resident_id },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.resident_id = $event.target.value
                              }
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.for_agency
                    ? _c("div", { staticClass: "col-6" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn border-btn mt-2",
                              class: _vm.errors.includes("cr_file")
                                ? "error"
                                : "",
                              on: {
                                click: function($event) {
                                  return _vm.onPickFile("cr_file")
                                }
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.helper.t(
                                      "* Commercial Registration Document"
                                    )
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm.cr_file != null
                            ? _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.cr_file["file"].substring(0, 24) +
                                      "..." +
                                      _vm.cr_file["file"].substring(
                                        _vm.cr_file["file"].length - 4
                                      )
                                  )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("input", {
                            ref: "cr_file",
                            staticStyle: { display: "none" },
                            attrs: {
                              type: "file",
                              accept:
                                "image/png, image/gif, image/jpeg, application/pdf"
                            },
                            on: { change: _vm.onFileCrFilePicked }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.for_agency
                    ? _c("div", { staticClass: "col-6" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn border-btn mt-2",
                              class: _vm.errors.includes("fl_file")
                                ? "error"
                                : "",
                              on: {
                                click: function($event) {
                                  return _vm.onPickFile("fl_file")
                                }
                              }
                            },
                            [
                              _c("p", [
                                _vm._v(
                                  _vm._s(_vm.helper.t("* Fal License Document"))
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _vm.fl_file != null
                            ? _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.fl_file["file"].substring(0, 24) +
                                      "..." +
                                      _vm.fl_file["file"].substring(
                                        _vm.fl_file["file"].length - 4
                                      )
                                  )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("input", {
                            ref: "fl_file",
                            staticStyle: { display: "none" },
                            attrs: {
                              type: "file",
                              accept:
                                "image/png, image/gif, image/jpeg, application/pdf"
                            },
                            on: { change: _vm.onFileFlFilePicked }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.for_agency
                    ? _c("div", { staticClass: "col-12" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex show-hand pt-3",
                              class: _vm.confirm_form_error ? "error" : "",
                              on: {
                                click: function($event) {
                                  _vm.confirm_form = !_vm.confirm_form
                                }
                              }
                            },
                            [
                              _vm.confirm_form
                                ? _c("i", {
                                    staticClass: "ri-checkbox-circle-fill px-2"
                                  })
                                : _c("i", {
                                    staticClass:
                                      "ri-checkbox-blank-circle-line px-2"
                                  }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.helper.t(
                                      "I confirm that above information is currect and accurate."
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.loading &&
                  !_vm.otp_sent &&
                  (!_vm.for_agency || _vm.confirm_form)
                    ? _c("div", { staticClass: "col-12 pt-3" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn default-btn register",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.sendMobileVerification()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.helper.t("Send OTP")) +
                                "\n                    "
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.loading && _vm.otp_sent
                    ? _c("div", { staticClass: "form-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.otp,
                              expression: "otp"
                            }
                          ],
                          staticClass: "form-control border-radius",
                          attrs: {
                            type: "text",
                            placeholder: _vm.helper.t("Enter OTP here")
                          },
                          domProps: { value: _vm.otp },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.otp = $event.target.value
                            }
                          }
                        })
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.loading && _vm.otp_sent
                    ? _c("p", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.helper.t("Enter the OTP sent on {0}", [
                                _vm.mobile
                              ])
                            ) +
                            "\n                "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.loading &&
                  _vm.otp_sent &&
                  (!_vm.for_agency || _vm.confirm_form)
                    ? _c("div", { staticClass: "col-12" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn default-btn",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.confirm_otp_and_register()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.helper.t("Register now")) +
                                "\n                    "
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              ]
            ),
            _vm._v(" "),
            !_vm.form_sent && _vm.loading
              ? _c("center", [_vm._v(_vm._s(_vm.helper.t("Please wait")))])
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-b6aefb14_0", { source: "\n.toggle-btn {\r\n    background-color: #e3e9ed !important;\r\n    color: #014116 !important;\n}\n.toggle-btn.active {\r\n    background-color: #014116 !important;\r\n    color: white !important;\n}\n.btn.error {\r\n    border: 1px solid red !important;\n}\r\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/widgets/register-widget.vue"],"names":[],"mappings":";AA0XA;IACA,oCAAA;IACA,yBAAA;AACA;AACA;IACA,oCAAA;IACA,uBAAA;AACA;AACA;IACA,gCAAA;AACA","file":"register-widget.vue","sourcesContent":["<template>\r\n    <div class=\"add-listing\">\r\n        <div v-if=\"registration_policy && !continue_to_signup\" style=\"padding: 10px;\r\n        background: #eeeeee;\r\n        border: 2px grey SOLID;\r\n        height: 300px;\r\n        overflow: auto;\">\r\n            <div v-html=\"registration_policy\">\r\n            </div>\r\n            <div class=\"features-content mt-2\">\r\n                <ul class=\"d-flex justify-content-start\">\r\n                    <li role=\"button\" @click=\"policy_agreed = !policy_agreed;\">\r\n                        <i v-if=\"policy_agreed\" class=\"ri-checkbox-circle-fill\"></i>\r\n                        <i v-else class=\"ri-checkbox-blank-circle-line\"></i>\r\n                        {{helper.t(\"I agree\")}}\r\n                    </li>\r\n                </ul>\r\n                <a  v-if=\"policy_agreed\" href=\"#\" @click.prevent=\"continue_to_signup = true\" class=\"btn default-btn equalizer\">\r\n                    {{ helper.t(\"Continue to Sign Up\") }}\r\n                </a>\r\n            </div>\r\n        </div>\r\n        <h3 v-if=\"policy_agreed && continue_to_signup\">{{helper.t(\"Sign Up\")}}</h3>\r\n        <div v-if=\"policy_agreed && continue_to_signup\" class=\"user-form-content sign-up\">\r\n            <form class=\"user-form\" action=\"#\" method=\"post\">\r\n                <div class=\"row\">\r\n                    <div class=\"col-12 p-2\">\r\n                        <ul class=\"nav nav-pills mb-3\" id=\"pills-tab\" role=\"tablist\">\r\n                            <li class=\"nav-item\" role=\"presentation\">\r\n                                <button class=\"nav-link toggle-btn\" :class=\"for_agency?'active':''\" type=\"button\" role=\"tab\" @click=\"for_agency = true\">{{helper.t(\"Agency\")}}</button>\r\n                            </li>\r\n                            <li class=\"nav-item\" role=\"presentation\">\r\n                                <button class=\"nav-link toggle-btn\" :class=\"!for_agency?'active':''\" type=\"button\" role=\"tab\" @click=\"for_agency = false\">{{helper.t(\"Individual User\")}}</button>\r\n                            </li>\r\n                        </ul>\r\n                    </div>\r\n                    <div class=\"col-12\">\r\n                        <div class=\"form-group\">\r\n                            <input class=\"form-control border-radius\" :class=\"errors.includes('mobile')?'error':''\"\r\n                                v-model=\"mobile\" type=\"text\"\r\n                                :placeholder=\"helper.t(for_agency?'* Mobile Number for the Entity\\'s Main Account (05xxxxxxxx)':'* Mobile Number (05xxxxxxxx)')\"\r\n                                :disabled=\"loading || otp_sent\">\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"col-12\">\r\n                        <div class=\"form-group\">\r\n                            <input class=\"form-control border-radius\" :class=\"errors.includes('full_name')?'error':''\" v-model=\"full_name\" type=\"text\" :placeholder=\"'*'+helper.t(for_agency?'Entity Name According to Commercial Registration':'Full Name')\" :disabled=\"loading\">\r\n                        </div>\r\n                    </div>\r\n                    <div class=\"col-12\">\r\n                        <div class=\"form-group\">\r\n                            <input class=\"form-control border-radius\" :class=\"errors.includes('email')?'error':''\" v-model=\"email_address\" type=\"text\" :placeholder=\"helper.t('Email (optional)')\" :disabled=\"loading\">\r\n                        </div>\r\n                    </div>\r\n                    <div v-if=\"for_agency\" class=\"col-12\">\r\n                        <div class=\"form-group\">\r\n                            <input class=\"form-control border-radius\" :class=\"errors.includes('resident_id')?'error':''\" v-model=\"resident_id\" type=\"text\" :placeholder=\"helper.t('* Commercial Registration Number')\" :disabled=\"loading\">\r\n                        </div>\r\n                    </div>\r\n                    <div v-if=\"for_agency\" class=\"col-6\">\r\n                        <div class=\"form-group\">\r\n                            <a class=\"btn border-btn mt-2\"\r\n                                @click=\"onPickFile('cr_file')\"\r\n                                :class=\"errors.includes('cr_file')?'error':''\" >\r\n                                <p>{{ helper.t(\"* Commercial Registration Document\") }}</p>\r\n                            </a>\r\n                            <p v-if=\"cr_file != null\">{{ cr_file[\"file\"].substring(0,24) + \"...\" + cr_file[\"file\"].substring(cr_file[\"file\"].length-4) }}</p>\r\n                            <input\r\n                                type=\"file\"\r\n                                style=\"display: none\"\r\n                                ref=\"cr_file\"\r\n                                accept=\"image/png, image/gif, image/jpeg, application/pdf\"\r\n                                @change=\"onFileCrFilePicked\"/>\r\n                        </div>\r\n                    </div>\r\n                    <div v-if=\"for_agency\" class=\"col-6\">\r\n                        <div class=\"form-group\">\r\n                            <a class=\"btn border-btn mt-2\"\r\n                            @click=\"onPickFile('fl_file')\"\r\n                            :class=\"errors.includes('fl_file')?'error':''\" >\r\n                                <p>{{ helper.t(\"* Fal License Document\") }}</p>\r\n                            </a>\r\n                            <p v-if=\"fl_file != null\">{{ fl_file[\"file\"].substring(0,24) + \"...\" + fl_file[\"file\"].substring(fl_file[\"file\"].length-4) }}</p>\r\n                            <input\r\n                                type=\"file\"\r\n                                style=\"display: none\"\r\n                                ref=\"fl_file\"\r\n                                accept=\"image/png, image/gif, image/jpeg, application/pdf\"\r\n                                @change=\"onFileFlFilePicked\"/>\r\n                        </div>\r\n                    </div>\r\n                    <div v-if=\"for_agency\" class=\"col-12\">\r\n                        <div class=\"form-group\">\r\n                            <div class=\"d-flex show-hand pt-3\"\r\n                                :class=\"confirm_form_error?'error':''\"\r\n                                @click=\"confirm_form = !confirm_form;\">\r\n                                <i v-if=\"confirm_form\" class=\"ri-checkbox-circle-fill px-2\"></i>\r\n                                <i v-else class=\"ri-checkbox-blank-circle-line px-2\"></i>\r\n                                {{helper.t(\"I confirm that above information is currect and accurate.\")}}\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div v-if=\"!loading && !otp_sent && (!for_agency || confirm_form)\" class=\"col-12 pt-3\">\r\n                        <button class=\"btn default-btn register\" @click=\"sendMobileVerification()\" type=\"button\">\r\n                            {{ helper.t(\"Send OTP\") }}\r\n                        </button>\r\n                    </div>\r\n                    <div v-if=\"!loading && otp_sent\" class=\"form-group\">\r\n                        <input\r\n                        class=\"form-control border-radius\"\r\n                        v-model=\"otp\"\r\n                        type=\"text\"\r\n                        :placeholder=\"helper.t('Enter OTP here')\"/>\r\n                    </div>\r\n                    <p v-if=\"!loading && otp_sent\">\r\n                        {{ helper.t(\"Enter the OTP sent on {0}\",[mobile]) }}\r\n                    </p>\r\n                    <div v-if=\"!loading && otp_sent && (!for_agency || confirm_form)\" class=\"col-12\">\r\n                        <button class=\"btn default-btn\" @click=\"confirm_otp_and_register()\" type=\"button\">\r\n                            {{ helper.t(\"Register now\") }}\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n            <center v-if=\"!form_sent && loading\" >{{ helper.t(\"Please wait\") }}</center>\r\n        </div>\r\n    </div>\r\n</template>\r\n\r\n<script>\r\n\timport * as global from \"../../js/global\";\r\n\timport * as helper from \"../../js/helper\";\r\n\timport full_loading from \"../components/full-loading.vue\";\r\n\texport default{\r\n        components: {\r\n            full_loading:full_loading,\r\n        },\r\n\t\tname:'login_widget',\r\n        props:{\r\n        },\r\n        data: function(){\r\n            return {\r\n                global,\r\n                helper,\r\n                frappe,\r\n                exceptions:[],\r\n                loading: false,\r\n                for_agency: true,\r\n                full_name:\"\",\r\n                mobile:\"\",\r\n                email_address:\"\",\r\n                resident_id:\"\",\r\n                cr_file:null,\r\n                fl_file:null,\r\n                errors:[],\r\n                form_sent:false,\r\n                form_disable:false,\r\n                otp_sent:false,\r\n                wrong_otp:false,\r\n                otp:\"\",\r\n                t_sid: null,\r\n                reg_error:false,\r\n                reg_done:false,\r\n                registration_policy:null,\r\n                policy_agreed:false,\r\n                confirm_form:false,\r\n                confirm_form_error:false,\r\n                continue_to_signup:false\r\n            }\r\n        },\r\n        methods: {\r\n            load_data: async function(){\r\n                global.emitter.emit(\"show-full-loading\");\r\n                this.is_loading = true;\r\n                let params = {\r\n                };\r\n                let url = \"/api/method/maalek.api.get_registration_policy\";\r\n                let res = await $.ajax({\r\n                    url: url,\r\n                    type: \"GET\",\r\n                    data: params\r\n                });\r\n                this.registration_policy = res.message;\r\n                this.is_loading = false;\r\n                global.emitter.emit(\"hide-full-loading\");\r\n            },\r\n            isUserExist:async function(){\r\n                global.emitter.emit(\"show-full-loading\");\r\n                this.loading = true;\r\n                try {\r\n                    let params = {\r\n                        \"phone_number\":this.mobile,\r\n                    }\r\n                    let res = await $.ajax({\r\n                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                        url: \"/api/method/maalek.api.is_user_exist\",\r\n                        type: \"GET\",\r\n                        data: params //for GET request\r\n                        // data: JSON.stringify(params) //for POST request\r\n                    });\r\n                    if(res.message == false ){\r\n                        this.loading = false;\r\n                        global.emitter.emit(\"hide-full-loading\");\r\n                        return false\r\n                    }\r\n                    this.loading = false;\r\n                    global.emitter.emit(\"hide-full-loading\");\r\n                    helper.showException(\"Mobile number already registered\");\r\n                    return true\r\n                } catch (e) {\r\n                    this.loading = false;\r\n                    global.emitter.emit(\"hide-full-loading\");\r\n                    var exceptions = helper.showException(e);\r\n                    return true\r\n                }\r\n            },\r\n            sendMobileVerification: async function(){\r\n                if(!this.verify_form()){\r\n                    this.show_errors();\r\n                    return;\r\n                }\r\n                if(await this.isUserExist()){\r\n                    return;\r\n                }\r\n                this.loading = true;\r\n                let params = {\r\n                    mobile_no : '+966'+this.mobile.substring(1, this.mobile.length)\r\n                };\r\n                try {\r\n                    let res = await $.ajax({\r\n                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                        url: \"/api/method/maalek.api.twilio_api.send_otp\",\r\n                        type: \"GET\",\r\n                        data: params //for GET request\r\n                        // data: JSON.stringify(params) //for POST request\r\n                    });\r\n                    this.t_sid = res.message;\r\n                    this.form_disable = true;\r\n                    this.otp_sent = true;\r\n                    this.loading = false;\r\n                } catch (e) {\r\n                    console.log(e);\r\n                    this.loading = false;\r\n                    this.otp_sent = false;\r\n                    this.form_disable = false;\r\n                    var exceptions = helper.showException(e);\r\n                }\r\n            },\r\n            onPickFile: function(ref){\r\n                this.$refs[ref].click()\r\n            },\r\n            onFileCrFilePicked: function(event) {\r\n                const files = event.target.files\r\n                if (files && files[0]) {\r\n                    this.cr_file = {};\r\n                    this.cr_file[\"file\"] = files[0].name;\r\n                    this.cr_file[\"type\"] = files[0].type;\r\n                    const fileReader = new FileReader();\r\n                    fileReader.readAsDataURL(files[0]);\r\n                    let reader = new FileReader;\r\n                    reader.onload = e => {\r\n                        this.cr_file[\"data\"] = e.target.result;\r\n                    }\r\n                    reader.readAsDataURL(files[0]);\r\n                    this.$forceUpdate();\r\n                }\r\n            },\r\n            onFileFlFilePicked: function(event) {\r\n                const files = event.target.files\r\n                if (files && files[0]) {\r\n                    this.fl_file = {};\r\n                    this.fl_file[\"file\"] = files[0].name;\r\n                    this.fl_file[\"type\"] = files[0].type;\r\n                    const fileReader = new FileReader();\r\n                    fileReader.readAsDataURL(files[0]);\r\n                    let reader = new FileReader;\r\n                    reader.onload = e => {\r\n                        this.fl_file[\"data\"] = e.target.result;\r\n                    }\r\n                    reader.readAsDataURL(files[0]);\r\n                    this.$forceUpdate();\r\n                }\r\n            },\r\n            confirm_otp_and_register: async function(){\r\n                this.form_sent = true;\r\n                let params = {\r\n                    \"mobile\":'+966'+this.mobile.substring(1, this.mobile.length),\r\n                    \"full_name\":this.full_name,\r\n                    \"email_address\":this.email_address,\r\n                    \"for_agency\":this.for_agency?1:0,\r\n                    \"resident_id\":this.resident_id,\r\n                    \"cr_file\":this.cr_file,\r\n                    \"fl_file\":this.fl_file,\r\n                    \"t_sid\":this.t_sid,\r\n                    \"otp\":this.otp\r\n                }\r\n                try {\r\n                    let res = await $.ajax({\r\n                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                        url: \"/api/method/maalek.api.register_user\",\r\n                        type: \"POST\",\r\n                        // data: params //for GET request\r\n                        data: JSON.stringify(params) //for POST request\r\n                    });\r\n                    if (res.full_name != null && res.full_name != \"\") {\r\n                        this.reg_error = false;\r\n                        this.reg_done = true;\r\n                        window.location.replace(document.referrer);\r\n                        return;\r\n                    }\r\n                    this.reg_error = true;\r\n                    this.reg_done = false;\r\n                    helper.showException(\"There is something wrong. Please try again.\");\r\n                } catch (e) {\r\n                    this.reg_error = true;\r\n                    this.reg_done = false;\r\n                    var exceptions = helper.showException(e);\r\n                }\r\n                \r\n                this.loading = false\r\n            },\r\n            verify_form: function(){\r\n                this.errors = [];\r\n                if(this.full_name.length < 3){\r\n                    this.errors.push(\"full_name\");\r\n                }\r\n                if(!this.mobile.match('^05[0-9]{8}$')) {\r\n                    this.errors.push(\"mobile\");\r\n                }\r\n                var mailformat = /^(([^<>()[\\]\\\\.,;:\\s@\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/;\r\n                var trimed_email = this.email_address.replace(/\\s+/g, \"\");\r\n                if(trimed_email.length > 0 && !trimed_email.match(mailformat)){\r\n                    this.errors.push(\"email\");\r\n                }\r\n                if(this.for_agency && (!this.resident_id || this.resident_id.length != 10)){\r\n                    this.errors.push(\"resident_id\");\r\n                }\r\n                if(this.for_agency && this.cr_file == null){\r\n                    this.errors.push(\"cr_file\");\r\n                }\r\n                if(this.for_agency && this.fl_file == null){\r\n                    this.errors.push(\"fl_file\");\r\n                }\r\n                if(this.errors.length > 0){\r\n                    return false;\r\n                }\r\n                return true;\r\n            },\r\n            show_errors: function(){\r\n                if(this.errors.includes(\"full_name\")){\r\n                    return helper.showException(\"Please enter your full name\");\r\n                }\r\n                if(this.errors.includes(\"mobile\")) {\r\n                    return helper.showException(\"Please enter valid mobile no. (05xxxxxxxx)\");\r\n                }\r\n                if(this.errors.includes(\"email\")){\r\n                    return helper.showException(\"Please enter valid email address\");\r\n                }\r\n                if(this.errors.includes(\"resident_id\")){\r\n                    return helper.showException(\"You must enter your company's registration id.\");\r\n                }\r\n                if(this.errors.includes(\"cr_file\")){\r\n                    return helper.showException(\"You must provide Company Registration Document\");\r\n                }\r\n                if(this.errors.includes(\"fl_file\")){\r\n                    return helper.showException(\"You must provide Fal License Document\");\r\n                }\r\n            },\r\n        }, \r\n        mounted() {\r\n            this.load_data();\r\n        },\r\n        computed:{\r\n        }\r\n\t}\r\n</script>\r\n\r\n<style>\r\n.toggle-btn {\r\n    background-color: #e3e9ed !important;\r\n    color: #014116 !important;\r\n}\r\n.toggle-btn.active {\r\n    background-color: #014116 !important;\r\n    color: white !important;\r\n}\r\n.btn.error {\r\n    border: 1px solid red !important;\r\n}\r\n</style>\r\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/widgets/register-widget.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__